<template>
  <v-container grid-list-md text-xs-left v-if="productStockSettingSingle !== null && pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
        v-for="breadcrumb in breadcrumbs"
        :key="breadcrumb.name"
        :disabled="typeof breadcrumb.link === 'undefined'"
        :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">{{productStockSettingSingle.title}}</h1>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs8>
        <v-layout column>
          <v-flex>

            <v-layout row class="elevation-1 white mb-4 pa-3">
              <v-flex xs6>
                <v-avatar
                  :tile="false"
                  :size="72"
                  color="grey lighten-4"
                  class="ma-3 float-left"
                >
                  <img :src="productStockSettingSingle.created_user.photo.url_resized" alt="avatar">
                </v-avatar>
                <div>
                  <p class="title mt-4">{{productStockSettingSingle.created_user.surname + ' ' + productStockSettingSingle.created_user.first_name + ' ' + productStockSettingSingle.created_user.patronymic}}</p>
                  <p class="body-2 mt-3">{{productStockSettingSingle.created_user.user_group.title}}</p>
                </div>
              </v-flex>
            </v-layout>

            <v-layout class="elevation-1 white mb-4 pa-3">
              <v-flex xs6>
                <div>
                  <span class="title">Дата создания: </span>
                  <span class="title font-weight-thin">{{ $moment(productStockSettingSingle.created_datetime).format('D MMM YYYY, HH:mm') }}</span>
                </div>
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <p class="title ml-3" v-if="branchList.length > 0">Филиалы</p>
    <v-layout class="ml-3 mb-3" v-if="branchList.length > 0">
      <v-flex xs6 lg6 md6 class="pa-0">
        <v-card class="elevation-1 py-3">
          <v-card-text class="text-lg-left py-0" v-for="(branch, index) in branchList" :key="index">{{branch.title}}</v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <p class="title ml-3" v-if="productList.length > 0">Список SKU</p>
    <v-layout class="ml-3" v-if="productList.length > 0">
      <v-flex xs6 lg6 md6 class="pa-0">
        <v-card class="elevation-1 py-3">
          <v-card-text class="text-lg-left py-0" v-for="(product, index) in productList" :key="index">{{product.title}}</v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-snackbar
      v-model="actions.enabled"
      :right="true"
      :timeout="0"
      class="single-page-actions"
    >
      <div>
        <v-btn dark small color="primary" v-if="actions.canUpdate" @click="editProductStockSetting(id)">
          <v-icon dark>edit</v-icon>
        </v-btn>
        <v-btn dark small color="error" v-if="actions.canRemove" @click="deleteDialog = true">
          <v-icon dark>delete</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <v-dialog
      v-model="deleteDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title class="headline">Удалить скрытый остаток?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error"
            @click="deleteProductStockSettingConfirm(id)"
          >
            Удалить
          </v-btn>

          <v-btn
            @click="deleteDialog = false"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Список скрытых остатков', link: '/product/stock/setting/active'}
        ],
        actions: {
          enabled: false,
          canUpdate: false,
          canRemove: false
        },
        id: null,
        pageDataReady: {
          isReady: false,
          productStockSetting: false
        },
        productList: [],
        branchList: [],
        deleteDialog: false
      }
    },
    beforeCreate () {
      this.$store.commit('setPageLoading', true)
      this.$store.dispatch('getProductStockSettingSingle', {id: this.$route.params.id})
    },
    computed: {
      productStockSettingSingle () {
        return this.$store.getters.productStockSettingSingle
      }
    },
    methods: {
      editProductStockSetting (id) {
        this.$router.push('/product/stock/setting/edit/' + id)
      },
      deleteProductStockSettingConfirm () {
        this.deleteDialog = false
        this.$store.dispatch('deleteProductStockSetting', {id: this.id}).then(() => {
          this.$router.push('/product/stock/setting/active/1')
        })
      },
      pageDataStatus () {
        if (!this.pageDataReady.productStockSetting) {
          return false
        }

        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      }
    },
    watch: {
      productStockSettingSingle () {
        if (this.productStockSettingSingle.mode === 'active') {
          this.actions.enabled = true
        } else {
          this.actions.enabled = false
        }
        this.id = this.productStockSettingSingle.id
        this.actions.canUpdate = this.productStockSettingSingle.can_update
        this.actions.canRemove = this.productStockSettingSingle.can_remove

        if ('branch_list' in this.productStockSettingSingle) {
          this.branchList = this.productStockSettingSingle.branch_list
        }

        if ('product_sku_list' in this.productStockSettingSingle) {
          this.productList = this.productStockSettingSingle.product_sku_list.map(item => {
            return {
              id: item.id,
              title: item.title,
              unit: item.unit,
              weight: item.weight
            }
          })
        }

        this.pageDataReady.productStockSetting = true
        this.pageDataStatus()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ProductStockSetting/ProductStockSettingSingle.vue